export default class ServiceNavMenu {
    constructor() {
        this.navMenu = null;
        this.toggleButton = null;
        this.menu = null;
    }

    init() {
        this.navMenu = document.querySelector('.service-nav-menu');
        if (!this.navMenu) return;

        this.toggleButton = this.navMenu.querySelector('.service-nav-toggle');
        this.menu = this.navMenu.querySelector('.menu');
        
        if (!this.toggleButton || !this.menu) return;

        this.setupMenuToggle();
        this.setupSubmenuToggles();
        this.setupKeyboardHandling();
        this.setupResizeHandler();
    }

    setupMenuToggle() {
        this.toggleButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            const isOpen = this.menu.classList.toggle('is-open');
            this.toggleButton.setAttribute('aria-expanded', isOpen);

            if (!isOpen) {
                this.closeAllSubmenus();
            }
        });

        document.addEventListener('click', (e) => {
            if (!this.navMenu.contains(e.target) && this.menu.classList.contains('is-open')) {
                this.menu.classList.remove('is-open');
                this.toggleButton.setAttribute('aria-expanded', 'false');
                this.closeAllSubmenus();
            }
        });
    }

    setupSubmenuToggles() {
        const parentItems = this.navMenu.querySelectorAll('.menu-item-has-children');
        
        parentItems.forEach((item) => {
            const link = item.querySelector(':scope > a');
            const submenu = item.querySelector('.sub-menu');
            
            if (!link || !submenu) return;

            link.addEventListener('click', (e) => {
                if (window.innerWidth <= 768) {
                    e.preventDefault();
                    
                    // Close other open submenus at same level
                    const siblings = Array.from(item.parentElement.children);
                    siblings.forEach((sibling) => {
                        if (sibling !== item && sibling.classList.contains('menu-item-has-children')) {
                            sibling.classList.remove('submenu-open');
                            const siblingSubmenu = sibling.querySelector('.sub-menu');
                            if (siblingSubmenu) {
                                siblingSubmenu.classList.remove('is-open');
                            }
                        }
                    });

                    const isOpen = submenu.classList.toggle('is-open');
                    item.classList.toggle('submenu-open', isOpen);
                }
            });
        });
    }

    setupKeyboardHandling() {
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.menu.classList.contains('is-open')) {
                this.menu.classList.remove('is-open');
                this.toggleButton.setAttribute('aria-expanded', 'false');
                this.closeAllSubmenus();
                this.toggleButton.focus();
            }
        });
    }

    setupResizeHandler() {
        let resizeTimer;
        
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                if (window.innerWidth > 768 && this.menu.classList.contains('is-open')) {
                    this.menu.classList.remove('is-open');
                    this.toggleButton.setAttribute('aria-expanded', 'false');
                    this.closeAllSubmenus();
                }
            }, 250);
        });
    }

    closeAllSubmenus() {
        const openSubmenus = this.menu.querySelectorAll('.sub-menu.is-open');
        const openParents = this.menu.querySelectorAll('.menu-item-has-children.submenu-open');
        
        openSubmenus.forEach((submenu) => {
            submenu.classList.remove('is-open');
        });
        
        openParents.forEach((parent) => {
            parent.classList.remove('submenu-open');
        });
    }
}
